import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';

const NavBar = (props)=>(
<nav className="mynav navbar navbar-expand-lg navbar-light my-10" > 
     <NavLink className='img-responsive' to="/"><img src={props.data.logo} className='img-responsive' alt="logoimg" style={{maxWidth:'100%', margin: 0}}/></NavLink>

      <h1 className="logoName">Old School Free Games</h1>

      <div className="ml-auto">
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse " id="navbarNavDropdown">
        <ul className="navbar-nav">
        <li className="nav-item dropdown">
           <NavLink className="nav-link dropdown-toggle" to="/" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
             {props.data.accountName}
            </NavLink>
            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              {props.data.opts}          
            </div>
          </li>
          <li className="nav-item">
            <NavLink to="/" className="nav-link active">Home</NavLink>
          </li>
          {(!props.data.usr)?'':(<li className="nav-item">
            <NavLink to="/games" className="nav-link active">Games</NavLink>
          </li>)}
          
          <li className="nav-item">
            <NavLink to="/soon" className="nav-link">Soon</NavLink>
          </li>
          <li className="nav-item">
           <NavLink to="/about" className="nav-link">About</NavLink>
          </li>
          
        </ul>
      </div>
      </div>
    </nav>)


export default NavBar;



// WEBPACK FOOTER //
// ./src/container/NavBar.js